import { baseArkhaleAPI } from './base-api'
import {
  NotificationTemplate,
  NotificationType,
} from '../../shared/models/notification.model'
import { Pagination } from '../../shared/models/others/pagination'
import { PaginationWithSearchTerm } from './query-type'
import { NotificationTemplateID } from '../../shared/models/id/notification_template_id'

const notificationTemplateApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => {
    return {
      getNotificationTemplates: build.query<
        Pagination<NotificationTemplate>,
        PaginationWithSearchTerm & {
          notificationType?: NotificationType
        }
      >({
        query: (args) => ({
          url: '/notifications/templates',
          method: 'GET',
          params: {
            offset: args.offset,
            limit: args.limit,
            textSearch: args.textSearch,
            notificationType: args.notificationType,
            //tenantID: args.tenantID,
          },
        }),
      }),
      getNotificationTemplate: build.query<
        NotificationTemplate,
        NotificationTemplateID
      >({
        query: (arg) => ({
          url: `/notifications/templates/${arg.id}`,
          method: 'GET',
        }),
      }),
      addNotificationTemplate: build.mutation<
        NotificationTemplate,
        NotificationTemplate
      >({
        query: (arg) => ({
          url: '/notifications/templates',
          method: 'POST',
          body: arg,
        }),
      }),
      updateNotificationTemplate: build.mutation<
        NotificationTemplate,
        NotificationTemplate
      >({
        query: (arg) => ({
          url: `/notifications/templates/${arg.id?.id}`,
          method: 'PUT',
          body: arg,
        }),
      }),
    }
  },
})

export const {
  useLazyGetNotificationTemplatesQuery,
  useLazyGetNotificationTemplateQuery,
  useAddNotificationTemplateMutation,
  useUpdateNotificationTemplateMutation,
} = notificationTemplateApi
